<template>
    <v-flex xs12 class="chapter-view">
        <v-flex v-if="currentCommunityView === userRoles.MEMBER">
            <chapterpage></chapterpage>
        </v-flex>
        <v-flex v-else-if="currentCommunityView === userRoles.ADMIN">
            <v-flex v-if="getCATools">
                <chapter-admin-view></chapter-admin-view>
            </v-flex>
            <v-flex v-else-if="getOverallChapterHealth">
                <overall-chapter-health></overall-chapter-health>
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
    import { mapGetters } from "vuex";
    import chapterpage from './ChapterPage';
    import { userRoles, routerNames } from '../appCommon.constants';
    import ChapterAdminView from '../ChapterPage/ChapterAdminView/ChapterAdminView';
    import { storeGetters } from '@/store/storeGetters.constant';
    import OverallChapterHealth from "./ChapterHealth/OverallChapterHealth.vue";

    export default {
        name: 'ChapterMain',
        components: {
            chapterpage,
            ChapterAdminView,
            OverallChapterHealth,
        },
        data: () => ({
            userRoles,
        }),
        computed: {
            ...mapGetters({
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                getCATools: `chapter/${storeGetters.getCATools}`,
                getOverallChapterHealth: `chapter/${storeGetters.getOverallChapterHealth}`,
            }),
            isChapterPage() {
                return this.$route.name === routerNames.CHAPTER;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .chapter-view {
        
    }

    .forum-table {
        .headding {
            background: $ypo-dark-gray;
            color: $white;
            padding: 10px;
            text-transform: uppercase;
            font-weight: 600;
            align-items: center;
        }

        &__grid {
            &__body {
                max-height: 250px;
                overflow-y: auto;
                margin-top: 5px;
                margin-bottom: 10px;

                .layout {
                    padding: 5px 0;
                }

                span {
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: block;
                    padding: 0 5px;
                }

                a {
                    padding: 0 10px;
                    color: $ypo_cta;
                    text-decoration: none;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: block;

                    &:hover {
                        text-decoration: underline;
                    }

                }
            }

            &.full {
                a {
                    display: inline-block;
                    margin-bottom: 7px;
                }

            }
        }

        &.chapter-reports {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;

            .see-more {
                padding: 15px 10px;
                background-color: $ypo-extra-light-gray;
                border-top: 1px $ypo-about-border solid;
                font-size: 10px;

                a {
                    text-decoration: none;
                    color: $ypo_cta;

                    &:hover {
                        text-decoration: underline;
                    }

                }
            }
        }
    }
</style>
